const TAG_APPEARANCES = ['success', 'warning', 'danger'];
const TAG_DISPLAYS = ['outlined', 'subtle'];
const TAG_ELEMS = ['button', 'a', 'div', 'span'];

export { TAG_APPEARANCES, TAG_DISPLAYS, TAG_ELEMS };
